import PackagingSelectorSFC from "./PackagingSelector.vue";
export const PackagingSelector = PackagingSelectorSFC;
